import { render, staticRenderFns } from "./EvalRoles.vue?vue&type=template&id=647f0c98"
import script from "./EvalRoles.vue?vue&type=script&lang=js"
export * from "./EvalRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports